import { Cookies } from 'react-cookie';
const cookies = new Cookies();
const userId = cookies.get('user_id');
export default userId;
